<div class="edition-marketing-container">
  @for (priceCard of priceCardData; track priceCard) {
    <section class="edition-card-container">
      <mat-card appearance="outlined" class="edition-marketing-card">
        <mat-card-content>
          @if (priceCard.name) {
            <div class="edition-title">
              {{ priceCard.name }}
            </div>
          }
          <div class="price-display-box">
            <ng-container>
              <billing-ui-price-display
                [appPrice]="appPrice"
                [align]="'start'"
                [currencyCode]="currency"
                [size]="'large'"
                [editionId]="priceCard.editionId || ''"
                [form]="'verbose'"
              ></billing-ui-price-display>
            </ng-container>
          </div>
          <div class="add-to-cart-button">
            @if (isEditionActionUsed) {
              <button
                mat-flat-button
                color="primary"
            (click)="
              editionActionClick.emit({
                appId: priceCard.appId,
                editionId: priceCard.editionId
              })
            "
                >
                <span>{{ 'FRONTEND.STORE.ADD_TO_CART' | translate }}</span>
              </button>
            }
          </div>
          @if (marketingType === 1) {
            @if (priceCard.resellerMarketing) {
              <div>
                @if (priceCard.resellerMarketing.description) {
                  <div class="marketing-description">
                    {{ priceCard.resellerMarketing.description }}
                  </div>
                }
                @if (priceCard.resellerMarketing.keySellingPoints) {
                  <ul class="marketing-ks">
                    @for (ks of priceCard.resellerMarketing.keySellingPoints; track ks) {
                      <li>
                        <p>{{ ks }}</p>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          } @else {
            @if (priceCard.endUserMarketing) {
              <div>
                @if (priceCard.endUserMarketing.description) {
                  <div class="marketing-description">
                    {{ priceCard.endUserMarketing.description }}
                  </div>
                }
                @if (priceCard.endUserMarketing.keySellingPoints) {
                  <ul class="marketing-ks">
                    @for (ks of priceCard.endUserMarketing.keySellingPoints; track ks) {
                      <li>
                        <p>{{ ks }}</p>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          }
        </mat-card-content>
      </mat-card>
    </section>
  }
</div>
